import { ConcreteEncodable } from "./ConcreteEncodable";

import { OpsExcClearingDataImplEncoder } from "../../encoder/OpsExcClearingDataImplEncoder";

import * as CubiqTS from "../../index";
import { OpsExcClearingData } from "../OpsExcClearingData";

export class OpsExcClearingDataImpl extends ConcreteEncodable implements OpsExcClearingData {
  public static enType: string = "com.bcdfx.model.OpsExcClearingDataImpl";

  /*FID=1*/
  public isAutoPostAck: boolean;
  /*FID=2*/
  public opsExceptionId: CubiqTS.Long | null = null;
  /*FID=3*/
  public externalDealId: string;
  /*FID=4*/
  public clearingData: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OpsExcClearingDataImplEncoder.Instance;
    this.setEncodableType(OpsExcClearingDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OpsExcClearingDataImpl[" +
      "isAutoPostAck=" +
      this.isAutoPostAck +
      "opsExceptionId=" +
      this.opsExceptionId +
      "externalDealId=" +
      this.externalDealId +
      "clearingData=" +
      this.clearingData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
